import React, { Component } from 'react'
import Header from '../components/Header'
import Card1 from '../components/cards/Card1'
import { connect } from 'react-redux';
import { changeStateValue } from '../redux/MainReducer';
import { getWhyUs } from '../actions/MainAction';
export class WhyUsPage extends Component {
  openModal=(data, lang, lang_id=1)=>{
    this.props.changeStateValue({
      name:"mainModal",
      value:{
        position:true,
        id: data?.id?data?.id:"",
        image: data?.image?data?.image:"",
        image_full_url: data?.image_full_url?data?.image_full_url:"",
       
        languages:
          {
            id:lang?.id?lang?.id:'',
            title:lang?.title?lang?.title:'',
            description:lang?.description?lang?.description:'',
            lang_id:lang_id
          }
        ,
        requiredsLang: ["description"],
        requireds:[],
        afterCallFunction:this.props.getWhyUs,
        afterParams:[],
        url:'admin-our-mission'
      }
    })
  }

  componentDidMount(){
    this.props.getWhyUs()
  }
  render() {
    const {whyUs} = this.props;
    return (
      <div className='p-[40px] w-full'>
        <Header onClickBtn={this.openModal.bind(this,"","",1)} btn={false} title="Şirkət Missiyamız" />
        <div className='grid-full-250 grid grid-cols-2 mt-[20px]'>
          
           {
              whyUs?
                  <Card1 
                    image={whyUs?.image_full_url}
                    video={whyUs?.video_full_url}
                    onChangeLang={(id)=>this.openModal(whyUs, whyUs.translates.find(x=>x.lang_id==id), id)} 
                    title1={whyUs?.translate?.title}
                    afterCallFunction={()=> this.props.getWhyUs()}
                    deleteBtn={false}
                  />:null
            }
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state)=>({
  whyUs: state.Data.whyUs
});
const mapDispatchToProps = {changeStateValue, getWhyUs}
export default connect(mapStateToProps, mapDispatchToProps)(WhyUsPage)





